import rcclUUID from '@rcg/uuid';

import { includes } from 'lib/helpers';

import { getDevice } from 'lib/device';
import { getCookie } from 'lib/utilities/Cookies';
import {
	CRUISING_CODES,
	EMPTY_CRUISE_RECOMMENDATION_ID,
	FILTERS,
	SESSION_KEY_CRUISE_RECOMMENDATION_ID,
	TRACKING_EVENT_PERSONALIZATION,
} from './constants';

export const getDefaultDataWithEventType = (data, query, eventType) => {
	const visitorData = getVisitorData(data);
	const visitData = getVisitData(data);
	const eventItems = getEventItems({ ...data, eventType }, query);
	const dataToSend = {
		...visitorData,
		...visitData,
		...eventItems,
	};

	return dataToSend;
};

export const getItineraryPanelData = (cruise, query) => {
	const {
		id,
		masterSailing: { itinerary },
		lowestPriceSailing,
		searchIndex,
		itineraries,
		brand,
	} = cruise;

	const visitorData = getVisitorData(cruise);
	const visitData = getVisitData(cruise);
	const eventItems = getEventItems(
		{
			...cruise,
			eventType: TRACKING_EVENT_PERSONALIZATION.OPEN_ITINERARY_PANEL,
		},
		query,
	);

	const listItineraries = Array.isArray(itineraries) ? itineraries : [];

	const data = {
		...visitorData,
		...visitData,
		...eventItems,
		groupId: id || null,
		startDate: lowestPriceSailing.startDate || null,
		shipCode: itinerary.ship ? itinerary.ship.code : null,
		destination: itinerary.destination ? itinerary.destination.code : null,
		ports: getPorts(itinerary.ports),
		itineraryImpressions: listItineraries.slice(0, searchIndex) || [],
		portImpressions: [],
		brand,
	};

	return data;
};

const getQualifiers = (query) => {
	return (Array.isArray(query) && query.join('|')) || '';
};

const getOtherParameters = (query) => {
	const otherParameters =
		query &&
		Object.entries(query)
			.map(([key, value]) => {
				if (!FILTERS.includes(key)) {
					return `${key}=${value}`;
				}
			})
			.filter((value) => value)
			.join('&');

	return otherParameters;
};

const getFilters = (filters) => {
	const filtersInLine =
		filters &&
		Object.entries(filters)
			.map(([key, value]) => (value.length ? `${key}:${value}` : ''))
			.join('|');
	return filtersInLine || '';
};

const getAdobeMarketingCloudId = () => {
	return typeof window !== 'undefined' && window['visitor'] && window['visitor'].getMarketingCloudVisitorID
		? window['visitor'].getMarketingCloudVisitorID()
		: null;
};

const getPorts = (ports) => {
	return ports
		? ports.reduce((filteredPorts, port) => {
				if (!includes(filteredPorts, port.code) && !includes(CRUISING_CODES, port.code)) {
					filteredPorts.push(port.code);
				}

				return filteredPorts;
			}, [])
		: [];
};

const getVisitorData = (data) => {
	const { cruiseRecommendationId = EMPTY_CRUISE_RECOMMENDATION_ID } = data || {};

	const dataToAdd = {
		rwdId: rcclUUID.getRWDId() || '',
		adobeMarketingCloudId: getAdobeMarketingCloudId() || getCookie('MCMID') || '',
		consumerId: getCookie('consumerId') || '',
		recipientId: getCookie('recipientId') || '',
		device: getDevice(),
		cruiseRecommendationId: sessionStorage.getItem(SESSION_KEY_CRUISE_RECOMMENDATION_ID) || cruiseRecommendationId || EMPTY_CRUISE_RECOMMENDATION_ID,
	};

	return dataToAdd;
};

const getVisitData = (data) => {
	const {
		brand,
		locale: { country, currency, language, market },
	} = data;

	const dataToAdd = {
		market,
		country,
		language,
		currency,
		brand,
	};

	return dataToAdd;
};

const getEventItems = (data, query) => {
	const { searchApplied, qualifiersApplied, eventType } = data;

	const timeStamp = new Date().getTime().toString();

	const dataToAdd = {
		eventType,
		eventSubtype: '',
		eventSentTimestamp: timeStamp,
		searchParams: getFilters(searchApplied),
		qualifierParams: getQualifiers(qualifiersApplied),
		otherParams: getOtherParameters(query),
	};

	return dataToAdd;
};
